import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/quotation';

export type Activities = Awaited<ReturnType<(typeof service)['getActivities']>>;

export function getActivitiesOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Activities>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['quotations', 'activities', guid, [search]],
    queryFn: async () => await service.getActivities(guid, search),
    initialData,
  });
}
